import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="max-w-lg mx-auto text-center py-24 px-4" data-testid="not-found-page">
    <div className="text-xs tracking-[0.3em] uppercase text-[#8C6D46] mb-3">404</div>
    <h1 className="font-serif text-5xl font-semibold text-[#1E2A24]">Page not found</h1>
    <p className="text-sm text-[#64748B] mt-4">
      The page you are looking for doesn&apos;t exist or has been moved.
    </p>
    <Link
      to="/"
      className="inline-block mt-8 bg-[#2D5A47] hover:bg-[#214435] text-white px-6 py-3 rounded-lg font-semibold"
      data-testid="not-found-home"
    >
      Back to home
    </Link>
  </div>
);

export default NotFound;
